<template>
  <div class="show-groups">
    <van-button
      round
      type="warning"
      size="small"
      class="btn-show-groups"
      v-if="isShowGroup"
      @click="dealMatchGroup(matchGroup)"
      >分组</van-button
    >
    <!-- 显示投稿分类 -->
    <van-overlay :show="isShowContributeType">
      <van-picker
        class="match-group"
        show-toolbar
        title="请选择分类"
        :columns="matchType"
        @cancel="hideContributeType"
        @confirm="confirmContributeType"
      />
    </van-overlay>
  </div>
</template>

<script>
import tools from "@/utils/common";
export default {
  data() {
    return {
      id: this.$route.params.id,
      isShowContributeType: false,
      detail: {},
      isShowGroup: false,
      matchType: [],
      matchGroup: [],
      isConcat: false
    };
  },
  methods: {
    dealMatchGroup(matchGroup) {
      console.log(matchGroup);
      if (this.matchType.length == 0) {
        if (matchGroup.length > 1) {
          // 如果大于1，显示赛事投稿类型 弹层
          for (let item of matchGroup) {
            this.matchType.push(item.groupname);
          }
          this.isShowContributeType = true;
        } else {
          this.$emit("getGid", matchGroup[0].gid);
        }
      } else {
        this.isShowContributeType = true;
      }
    },
    hideContributeType() {
      this.isShowContributeType = false;
    },
    confirmContributeType(val, index) {
      console.log(val, index);
      this.$emit("getGid", this.matchGroup[index].gid);
      this.isShowContributeType = false;
    },
  },
  created() {
    tools.getDetail({ id: this.$route.params.id }).then((res) => {
      if(!this.isConcat) {
        this.matchGroup = [{ gid: 0, groupname: "全部" }].concat(res.match_group);
        this.isConcat = true;
      }
      // this.matchGroup = [{ gid: 0, groupname: "全部" }].concat(res.match_group);
      // this.matchGroup = res.match_group;
      this.isShowGroup = res.match_group.length > 1;
      // console.log(this.matchType);
    });
  },
  // mounted() {
  //   this.matchGroup = [{ gid: 0, groupname: "全部" }].concat(this.matchGroup);
  // },
};
</script>

<style>
.show-groups{
  position: relative;
  z-index: 9;
}
.match-group {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
}
.btn-show-groups {
  position: fixed;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
}
</style>
